module.exports = __webpack_public_path__ + "img/senzorInfiz.9bb75891.png";